import { AuthContext } from "../../../../../../contexts/AuthContext.ts";
import { PentestContext } from "../../../../../../contexts/PentestContext.ts";
import { useCallback, useContext, useEffect, useState } from "react";
import { apiGetIOBlocksByTimestamp, apiGetLatestIOBlocks } from "../../../../../../sdk.ts";
import { LoggerContext } from "../../../../../../contexts/LoggerContext.ts";
import CommandList from "./components/CommandList/CommandList.tsx";
import axios from "axios";
import { IOBlock } from "../../../../../../sdkStructs.ts";

function CommandWidget() {
  const token = useContext(AuthContext).token;
  const pentestId = useContext(PentestContext).pentestId;

  const [refreshing, setRefreshing] = useState(false);

  const {
    highlightCommands,
    highlightRequests,
    selectedIOBlocks,
    setSelectedIOBlocks,
    setTokenDisplay,
    setEmptyLogger,
  } = useContext(LoggerContext);

  const [included, setIncluded] = useState<boolean[]>([true, true]);

  const [ioList, setIOList] = useState<IOBlock[]>([]);
  const [hasMore, setHasMore] = useState(true);

  const getLastLoggedInputOutput = useCallback(async (automatic: boolean) => {
    try {
      if(!automatic)
        setRefreshing(true);
      const response = await apiGetLatestIOBlocks(token, pentestId);
      if (!response.data){ 
        setTokenDisplay(true);
        return;
      }

      setIOList(response.data);
      setHasMore(true);
      if(response.data.length){
        setEmptyLogger(false);
      }
      setRefreshing(false);
    } catch (error) {
      if (!axios.isAxiosError(error)) {
        return;
      }
      console.log("ERROR FETCHING INPUT/OUTPUT:", error.response);
    }
  }, [token, pentestId, setTokenDisplay, setEmptyLogger]);

  useEffect(() => {
    const loadData = async () => {
      if (token && pentestId != -1) {
        await getLastLoggedInputOutput(true);
      }
    };

    loadData();
  }, [getLastLoggedInputOutput, pentestId, token]);

  async function loadMoreCommands() {
    const response = await apiGetIOBlocksByTimestamp(token, pentestId, -20, ioList[ioList.length - 1].timestamp);
    const new_io = response.data;

    if(new_io === null)
      setHasMore(false);
    else if (new_io) {
      new_io.sort((a, b) => {
        if (a.timestamp > b.timestamp) return -1;
        if (a.timestamp < b.timestamp) return 1;

        if (a.id > b.id) return 1;
        return -1;
      });

      const newArray = [...ioList, ...new_io];
      setIOList(newArray);
    }

    setEmptyLogger(false);
  }

  function selectIOBlock(element: IOBlock) {
    let newIOBlocks: IOBlock[];
    if (
      (element.type === "command" && highlightCommands[element.id]) ||
      (element.type === "request" && highlightRequests[element.id])
    ) {
      newIOBlocks = selectedIOBlocks.filter((x: IOBlock) => !(x.id === element.id && x.type === element.type));
    } else {
      newIOBlocks = selectedIOBlocks;
      newIOBlocks.push(element);
    }

    setSelectedIOBlocks(newIOBlocks);
  }

  return (
    <CommandList
      IOList={ioList}
      hasMore={hasMore}
      refresh={getLastLoggedInputOutput}
      loadMoreFunction={loadMoreCommands}
      included={included}
      setIncluded={setIncluded}
      selectBlock={selectIOBlock}
      refreshing={refreshing}
    />
  );
}

export default CommandWidget;
